import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import httpInstances from '@/api/axiosInstance';
import { forwardCurvesColumns, spotColumns } from '@/pages/Catalog/constants';
import type { CatalogItem } from '@/pages/Catalog/types';

export const useSpotCatalog = () => {
  return useQuery({
    queryKey: ['spotCatalog'],
    queryFn: async () => {
      try {
        const { data } = await httpInstances.axiosDataInstance.get(
          `/catalogue/spot?status=Live,Archive`,
          {
            headers: {
              fields: spotColumns.map(column => column.accessorKey)
            }
          }
        );
        const extendedWithSymbol: CatalogItem[] = data.map((catalogItem: CatalogItem) => ({
          ...catalogItem,
          Symbol: {
            Code: catalogItem.Code,
            Period: String(catalogItem.Period),
            PeriodType: catalogItem.PeriodType,
            TimeRef: catalogItem.TimeRef
          }
        }));

        return extendedWithSymbol;
      } catch (error) {
        if (error instanceof AxiosError && error.response) {
          const errorResponse = error.response.data;
          throw new Error(errorResponse.message || 'Request failed');
        }
        throw error;
      }
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000 // 5 minutes
  });
};

export const useForwardCatalog = () => {
  return useQuery({
    queryKey: ['forwardCatalog'],
    queryFn: async () => {
      try {
        const { data } = await httpInstances.axiosDataInstance.get(
          `/catalogue/curve?status=Live,Archive`,
          {
            headers: {
              fields: forwardCurvesColumns.map(column => column.accessorKey)
            }
          }
        );
        const extendedWithSymbol: CatalogItem[] = data.map((catalogItem: CatalogItem) => ({
          ...catalogItem,
          Symbol: {
            Code: catalogItem.Code,
            Period: String(catalogItem.Period),
            PeriodType: catalogItem.PeriodType,
            TimeRef: catalogItem.TimeRef
          }
        }));

        return extendedWithSymbol;
      } catch (error) {
        if (error instanceof AxiosError && error.response) {
          const errorResponse = error.response.data;
          throw new Error(errorResponse.message || 'Request failed');
        }
        throw error;
      }
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000 // 5 minutes
  });
};
